export default __webpack_public_path__ + "static/media/pen.52f2871b.svg";